import React from "react";
import { useSearchParams } from "react-router-dom";
import CustomCategoriesListView from "./CustomCategoriesListView";
import CustomCategoriesDetailView from "./CustomCategoriesDetailView";

export default function CustomCategoriesPage() {
  const [searchParams] = useSearchParams();
  const currentMode = searchParams.get("mode");

  switch (currentMode) {
    case "create":
    case "detail":
      return <CustomCategoriesDetailView />;
    default:
      return <CustomCategoriesListView />;
  }
}
